/**
 * IQ icon replicas from frontend/src/icons/.
 * Each icon matches the exact SVG paths from the main site.
 */

type IconProps = {
  color?: string;
  className?: string;
};

/** Interview Questions — dashboard/grid icon */
export function MissionControlIcon({
  color = "#155e75",
  className,
}: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6001 13.8C16.0478 13.8 15.6001 13.3523 15.6001 12.8L15.6001 4C15.6001 3.44772 16.0478 3 16.6001 3H20.0001C20.5524 3 21.0001 3.44771 21.0001 4V12.8C21.0001 13.3523 20.5524 13.8 20.0001 13.8L16.6001 13.8ZM4 13.8C3.44772 13.8 3 13.3523 3 12.8V7.6C3 7.04771 3.44772 6.6 4 6.6L11.9 6.6C12.4523 6.6 12.9 7.04771 12.9 7.6L12.9 12.8C12.9 13.3523 12.4523 13.8 11.9 13.8L4 13.8ZM8.3999 20C8.3999 20.5523 8.84762 21 9.3999 21L19.0999 21C19.6522 21 20.0999 20.5523 20.0999 20V17.5C20.0999 16.9477 19.6522 16.5 19.0999 16.5L9.3999 16.5C8.84762 16.5 8.3999 16.9477 8.3999 17.5L8.3999 20Z"
        fill={color}
      />
    </svg>
  );
}

/** Challenges — gauge/speedometer icon */
export function GaugeIcon({ color = "#155e75", className }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3924 6C7.44639 6.29232 4.29252 9.44606 4 13.392H5.58105C5.91242 13.392 6.18105 13.6607 6.18105 13.992C6.18105 14.3234 5.91242 14.592 5.58105 14.592H4.00015C4.11748 16.1642 4.6919 17.612 5.5887 18.8006H18.3954C19.2922 17.612 19.8666 16.1642 19.9839 14.592H18.4038C18.0724 14.592 17.8038 14.3234 17.8038 13.992C17.8038 13.6607 18.0724 13.392 18.4038 13.392H19.9841C19.6916 9.4463 16.5381 6.29271 12.5924 6.00005V7.58066C12.5924 7.91204 12.3238 8.18066 11.9924 8.18066C11.661 8.18066 11.3924 7.91204 11.3924 7.58066V6ZM9.25518 10.4116C9.04818 10.1528 8.6706 10.1108 8.41184 10.3179C8.15309 10.5249 8.11113 10.9024 8.31814 11.1612L10.7324 14.1791C10.6418 14.3646 10.5909 14.5731 10.5909 14.7935C10.5909 15.5675 11.2184 16.1949 11.9923 16.1949C12.7663 16.1949 13.3938 15.5675 13.3938 14.7935C13.3938 14.0195 12.7663 13.3921 11.9923 13.3921C11.8812 13.3921 11.7731 13.405 11.6695 13.4295L9.25518 10.4116Z"
        fill={color}
      />
    </svg>
  );
}

/** Takehomes — clipboard icon */
export function ClipboardIcon({ color = "#155e75", className }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0971 6.1534H17.6505C18.0777 6.1534 18.4272 6.50291 18.4272 6.9301V19.3573C18.4272 19.7845 18.0777 20.134 17.6505 20.134H6.7767C6.34951 20.134 6 19.7845 6 19.3573V6.9301C6 6.50291 6.34951 6.1534 6.7767 6.1534H8.3301M12.0368 5.3767C12.0368 5.28089 12.1177 5.2 12.2135 5.2C12.3093 5.2 12.3902 5.28089 12.3902 5.3767V5.5534H12.0368V5.3767ZM10.8368 5.5534V5.3767C10.8368 4.61814 11.455 4 12.2135 4C12.9721 4 13.5902 4.61814 13.5902 5.3767V5.5534H14.5436C14.875 5.5534 15.1436 5.82203 15.1436 6.1534V6.9301C15.1436 7.26147 14.875 7.5301 14.5436 7.5301H13.5902H12.9902H11.4368H10.8368H9.88341C9.55204 7.5301 9.28341 7.26147 9.28341 6.9301V6.1534C9.28341 5.82203 9.55204 5.5534 9.88341 5.5534H10.8368Z"
        fill={color}
      />
    </svg>
  );
}

/** Mock Interviews — chat bubble icon */
export function ChatIcon({ color = "#155e75", className }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 8C8 7.56 8.36 7.2 8.8 7.2H16V4.8C16 4.36 15.64 4 15.2 4H4.8C4.36 4 4 4.36 4 4.8V12C4 12.44 4.36 12.8 4.8 12.8H8V8Z"
        fill={color}
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15.2V8.00001C8 7.56001 8.36 7.20001 8.8 7.20001H19.2C19.64 7.20001 20 7.56001 20 8.00001V19.2L16.8 16H8.8C8.36 16 8 15.64 8 15.2ZM12.2 10.4C12.2 10.0686 12.4686 9.79998 12.8 9.79998H16.8C17.1313 9.79998 17.4 10.0686 17.4 10.4C17.4 10.7313 17.1313 11 16.8 11H12.8C12.4686 11 12.2 10.7313 12.2 10.4ZM10.6 12.8C10.6 12.4686 10.8686 12.2 11.2 12.2H16.8C17.1313 12.2 17.4 12.4686 17.4 12.8C17.4 13.1313 17.1313 13.4 16.8 13.4H11.2C10.8686 13.4 10.6 13.1313 10.6 12.8Z"
        fill={color}
      />
    </svg>
  );
}

/** Coaching — group of people icon */
export function GroupIcon({ color = "#155e75", className }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
        fill={color}
      />
    </svg>
  );
}

/** All Learning Paths / Company Interview Guides — open book icon */
export function OpenedBookIcon({ color = "#16a34a", className }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.4H4.8C4.36 19.4 4 19.04 4 18.6V5.8C4 5.36 4.36 5 4.8 5H12H19.2C19.64 5 20 5.36 20 5.8V18.6C20 19.04 19.64 19.4 19.2 19.4H12ZM5.5999 9.6H10.3999V8.4H5.5999V9.6ZM5.5999 12.8H10.3999V11.6H5.5999V12.8ZM10.3999 16H5.5999V14.8H10.3999V16ZM13.5999 12.8H18.3999V11.6H13.5999V12.8ZM18.3999 9.6H13.5999V8.4H18.3999V9.6Z"
        fill={color}
      />
    </svg>
  );
}

/** Blog — paper/document icon */
export function PaperIcon({ color = "#155e75", className }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.76 7.76L16.232 4.232C16.088 4.088 15.88 4 15.672 4H4.8C4.36 4 4 4.36 4 4.8V19.2C4 19.64 4.36 20 4.8 20H19.2C19.64 20 20 19.64 20 19.2V8.328C20 8.12 19.912 7.912 19.76 7.76ZM7.4 7.99999C7.4 7.66862 7.66863 7.39999 8 7.39999H13.6C13.9314 7.39999 14.2 7.66862 14.2 7.99999C14.2 8.33136 13.9314 8.59999 13.6 8.59999H8C7.66863 8.59999 7.4 8.33136 7.4 7.99999ZM8 11.4C7.66863 11.4 7.4 11.6686 7.4 12C7.4 12.3314 7.66863 12.6 8 12.6H16C16.3314 12.6 16.6 12.3314 16.6 12C16.6 11.6686 16.3314 11.4 16 11.4H8ZM8 15.4C7.66863 15.4 7.4 15.6686 7.4 16C7.4 16.3314 7.66863 16.6 8 16.6H16C16.3314 16.6 16.6 16.3314 16.6 16C16.6 15.6686 16.3314 15.4 16 15.4H8Z"
        fill={color}
      />
    </svg>
  );
}

/** Your Plan — map icon */
export function MapIcon({ color = "currentColor", className }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.0996 5V16.2001L18.9997 19.0001V7.80003L14.0996 5Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.20004 7.80003L14.1001 5V16.2001L9.20004 19.0001L5 16.2001V5L9.20004 7.80003L14.1001 5L9.20004 7.80003Z"
        fill={color}
      />
      <path
        d="M9.20004 7.80003L14.1001 5V16.2001L9.20004 19.0001L5 16.2001V5L9.20004 7.80003ZM9.20004 7.80003L14.1001 5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.2002 12.0001V7.80003L14.1002 5V16.2001"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Streak — fire icon */
export function FireIcon({
  color = "var(--iq-orange)",
  animate = false,
  className,
}: IconProps & { animate?: boolean }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      stroke={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {animate && (
        <animate
          attributeName="opacity"
          values=".7;1;.7"
          dur="2s"
          repeatCount="indefinite"
        />
      )}
      <path
        fill={color}
        d="M10.3671 4.06132C9.6671 4.56707 5 8.15805 5 13.9996C5 14.9188 5.18106 15.8291 5.53284 16.6784C5.88463 17.5277 6.40024 18.2993 7.05025 18.9493C7.70026 19.5993 8.47194 20.115 9.32122 20.4667C10.146 20.8084 11.0282 20.989 11.9203 20.9991C9.74796 20.9567 8 19.1824 8 16.9999C8 16.8024 8.01432 16.6082 8.04197 16.4184C8.04315 16.4071 8.04459 16.3957 8.04628 16.3843C8.3817 14.1305 10.4553 12.2171 11.4581 11.4101C11.7785 11.1523 12.2216 11.1523 12.5421 11.4101C13.5448 12.2171 15.6183 14.1305 15.9537 16.3843C15.9554 16.3957 15.9569 16.4071 15.958 16.4184C15.9857 16.6082 16 16.8024 16 16.9999C16 19.1824 14.252 20.9567 12.0797 20.9991C12.9718 20.989 13.854 20.8084 14.6788 20.4667C15.5281 20.115 16.2997 19.5993 16.9497 18.9493C17.5998 18.2993 18.1154 17.5277 18.4672 16.6784C18.807 15.8579 18.9875 14.9804 18.9994 14.093C18.9998 14.0815 19 14.07 19 14.0584L18.9999 14.0268L19 13.9997C18.9736 9.75902 16.1044 7.4446 15.5813 7.05781C15.5323 7.02155 15.4671 7.02196 15.4181 7.05823C15.2083 7.21337 14.6241 7.67639 13.9967 8.44729C13.9251 8.53521 13.7845 8.5184 13.7361 8.41591C12.5573 5.92135 10.9243 4.40726 10.5386 4.07102C10.4888 4.02764 10.4206 4.02266 10.3671 4.06132Z"
      />
    </svg>
  );
}

/** Salaries / Job Board — receipt icon */
export function ReceiptIcon({ color = "#155e75", className }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4V22L18 20.2L16 22L14 20.2L12 22L10 20.2L8 22L6 20.2L4 22V4H20ZM6.5 8.20894H17.9V7.00894H6.5V8.20894ZM15.6496 10.4767C15.6496 10.1453 15.381 9.87668 15.0496 9.87668C14.7182 9.87668 14.4496 10.1453 14.4496 10.4767V10.961C14.0391 11.0931 13.6672 11.3294 13.3916 11.6607L13.3909 11.6617C13.3522 11.7084 13.1877 11.91 13.0651 12.2044C12.9427 12.4986 12.84 12.9409 13.0127 13.4226L13.0127 13.4226L13.0141 13.4264C13.2237 13.9989 13.7147 14.2989 14.1057 14.5378L14.1456 14.5622C14.4265 14.7372 14.6163 14.8147 14.8144 14.8924L14.8427 14.9035C15.0126 14.97 15.1999 15.0433 15.5144 15.2056C15.859 15.3858 16.032 15.5065 16.1165 15.5767C16.1569 15.6103 16.1735 15.6294 16.1778 15.6346L16.1783 15.6352L16.1789 15.6359C16.2111 15.706 16.2191 15.7807 16.213 15.8551C16.2068 15.9312 16.1871 15.9893 16.1801 16.0087C16.1385 16.1138 16.054 16.2077 15.9281 16.2935C15.8114 16.373 15.696 16.4223 15.5901 16.4676L15.5534 16.4833L15.5534 16.4832L15.5461 16.4865C15.5466 16.4863 15.5469 16.4861 15.5469 16.4861C15.547 16.486 15.5469 16.486 15.5466 16.4861L15.5426 16.4875C15.5159 16.4967 15.3694 16.5474 15.1595 16.5686C15.1239 16.562 15.0872 16.5585 15.0496 16.5585C14.9996 16.5585 14.9509 16.5647 14.9045 16.5762C14.7317 16.5685 14.5481 16.5331 14.37 16.451L14.3694 16.4508C14.0917 16.3232 13.9398 16.1367 13.8631 16.0399C13.7848 15.9212 13.7433 15.8179 13.7195 15.7463C13.6153 15.4317 13.2759 15.2612 12.9613 15.3654C12.6467 15.4696 12.4762 15.8091 12.5804 16.1236C12.6316 16.2781 12.7203 16.4936 12.8818 16.7312C12.8902 16.7435 12.899 16.7555 12.9083 16.7672L12.9208 16.783C13.0177 16.9062 13.3186 17.2885 13.8683 17.5411C14.0654 17.6319 14.2615 17.6912 14.4496 17.7277V18.124C14.4496 18.4554 14.7182 18.724 15.0496 18.724C15.381 18.724 15.6496 18.4554 15.6496 18.124V17.7023C15.8307 17.6612 15.9647 17.6131 16.0303 17.5845L16.0418 17.5796L16.0627 17.571L16.063 17.5709C16.2727 17.4847 17.0138 17.1802 17.3006 16.438L17.3007 16.438L17.3032 16.4312C17.3404 16.3314 17.5709 15.7102 17.2352 15.0652C17.2299 15.055 17.2242 15.0449 17.2183 15.035C17.0803 14.8035 16.8462 14.5477 16.0689 14.1414L16.0663 14.14C15.6959 13.9488 15.4634 13.8578 15.28 13.786L15.28 13.786L15.2524 13.7752C15.0852 13.7096 14.9715 13.6631 14.7786 13.5427L14.7786 13.5427L14.7744 13.5401C14.2998 13.2495 14.1908 13.1482 14.1416 13.0158C14.1061 12.9149 14.1176 12.7986 14.1729 12.6657C14.2278 12.5341 14.3043 12.4401 14.3147 12.4275C14.5488 12.1464 15.0133 11.9714 15.4908 12.0606C15.955 12.1474 16.2766 12.4575 16.3711 12.8043C16.4582 13.124 16.788 13.3126 17.1077 13.2255C17.4274 13.1384 17.616 12.8086 17.5289 12.4888C17.3004 11.6503 16.5769 11.0428 15.7112 10.881C15.6907 10.8772 15.6702 10.8736 15.6496 10.8703V10.4767ZM11.25 11.0767H6.5V9.87667H11.25V11.0767ZM15.6496 17.7681H11.25V16.5681H6.5V17.7681ZM10.3 13.9444H6.5V12.7444H10.3V13.9444Z"
        fill={color}
      />
    </svg>
  );
}
